var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.4301,
    cy: 30.5004,
    r: 30.4301,
    fill: "#62C97F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3993 40.281L13.5999 31.4816C13.1257 31.0075 12.4826 30.7411 11.8121 30.7411C11.1416 30.7411 10.4985 31.0075 10.0243 31.4816C9.55019 31.9558 9.28381 32.5989 9.28381 33.2694C9.28381 33.6014 9.34921 33.9302 9.47627 34.2369C9.60333 34.5437 9.78956 34.8224 10.0243 35.0572L20.6242 45.657C21.6131 46.646 23.2107 46.646 24.1997 45.657L51.0289 18.8278C51.5031 18.3536 51.7694 17.7106 51.7694 17.04C51.7694 16.3695 51.5031 15.7264 51.0289 15.2522C50.5548 14.7781 49.9117 14.5117 49.2412 14.5117C48.5706 14.5117 47.9275 14.7781 47.4534 15.2522L22.3993 40.281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.760c9172b239032fe63f163754a94d9e.svg";
export { ForwardRef as ReactComponent };